export const SAVE_STATE_SET = 'dt/states/SAVE_STATE_SET';
export const STATE_SET_SAVED = 'dt/states/STATE_SET_SAVED';
export const REQUEST_STATE_SETS = 'dt/states/REQUEST_STATE_SETS';
export const LOADING_STATE_SETS = 'dt/states/LOADING_STATE_SETS';
export const RECEIVED_STATE_SETS = 'dt/states/RECEIVED_STATE_SETS';
export const UPDATE_STATE_SETS = 'dt/states/UPDATE_STATE_SETS';
export const DELETE_STATE_SET = 'dt/states/DELETE_STATE_SET';

export const saveStateSet = (data, site, org) => ({
  type: SAVE_STATE_SET,
  data,
  site,
  org,
});

export const stateSetSaved = () => ({
  type: STATE_SET_SAVED,
});

export const requestStateSets = (siteId) => ({
  type: REQUEST_STATE_SETS,
  siteId,
});

export const loadingStateSets = () => ({
  type: LOADING_STATE_SETS,
});

export const receivedStateSets = (stateSets, siteId) => ({
  type: RECEIVED_STATE_SETS,
  stateSets,
  siteId,
});

export const updateStateSet = (stateSet) => ({
  type: UPDATE_STATE_SETS,
  stateSet,
});

export const deleteStateSet = (stateSetId, siteId) => ({
  type: DELETE_STATE_SET,
  stateSetId,
  siteId,
});
